export default {
  "content": "<circle cx=\"216\" cy=\"200\" r=\"136\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M216 352v128m56-64H160m272-304V32h-80m-16.72 96.72L432 32\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};